<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                User Roles
            </template>
            <template v-slot:pageDetail>
                List
            </template>
        </o-bread-crumb>
        <div v-if="validation" class="validation-banner">
            <div class="validation-banner-inner">
                <div class="validation-icon">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="validation-message">
                    <strong>Error</strong>
                    <span>{{ validation }}</span>
                </div>
                <button class="validation-close" @click="validation = ''">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center bg-white shadow-none">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills flex-column flex-md-row justify-content-between ms-2 me-4 mt-2 mb-2 gap-3 gap-md-0">
                    <li class="nav-item text-start">
                        <div class="d-flex d-inline-block">
                            <h4 class="header-title mb-0">
                                <i class="fas fa-user-shield me-2 primary-icon"></i>List of User Roles
                            </h4>
                        </div>
                        <p class="header-subtitle mt-1 mb-0">Manage system roles and permissions</p>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="spinner d-flex justify-content-center align-items-center" v-if="page.isLoading">
                    <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div v-if="page.output">
                    <div class="filter-action-wrapper mb-4 mt-3">
                        <div class="filter-controls">
                            <div class="search-box-custom">
                                <div class="search-type-tabs">
                                    <button class="tab-btn active">Role Name</button>
                                </div>
                                <div class="search-input-wrapper">
                                    <input 
                                        type="text" 
                                        class="form-control-search" 
                                        v-model="searchCriteria" 
                                        placeholder="Search..." 
                                        @keyup.enter="doSearch()" 
                                    />
                                    <button v-if="!isSearchActive" class="btn-search" @click="doSearch()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button v-else class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="action-section">
                            <div class="action-buttons-group">
                                <button class="btn btn-refresh" @click.prevent="load_state()" title="Refresh">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                                <router-link v-if="write" :to="{ name: 'RoleForm' }" class="btn btn-add">
                                    <i class="fas fa-plus me-2"></i> Add New Role
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <o-table style="text-align:left;" class="table-hover member-list-table">
                        <thead>
                            <tr>
                                <th class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in roles" :key="index" class="member-row-clickable">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                                <td>{{ item.name && item.name.length > 25 ? item.name.substring(0, 25) + '..' : item.name }}</td>
                                <td>
                                    <button class="btn btn-action-secondary btn-sm" @click="showModules(item)">
                                        <i class="fas fa-eye me-1"></i> View
                                    </button>
                                </td>
                                <td class="ml-3">
                                    <div class="d-flex gap-2" @click.stop>
                                        <router-link v-if="write" class="btn btn-action btn-edit" :to="{ name: 'RoleEdit', params: { id: item.name } }">
                                            <i class="fas fa-edit me-1"></i> Edit
                                        </router-link>
                                        <button v-if="write" class="btn btn-action btn-delete" @click="showWarning(item.name)">
                                            <i class="fas fa-trash-alt me-1"></i> Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="roles.length === 0">
                                <td colspan="4" class="text-center">No roles available</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page" :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        <o-modal v-if="isModalVisible" @showModal="showModal" @close="isModalVisible = false">
            <template v-slot:header>
                {{ selectedRoleName ? `${selectedRoleName.length > 25 ? selectedRoleName.substring(0, 25) + '..' : selectedRoleName} Permissions` : 'Permissions' }}
            </template>
            <template v-slot:body>
                <div class="permission-simple-list">
                    <div v-for="(module, moduleIndex) in processedModules(modalModules)" :key="moduleIndex" class="permission-list-item">
                        <div class="permission-name-inline">
                            {{ formattedModuleName(module.name) }}
                        </div>
                        <div class="permission-badges">
                            <span class="badge badge-simple" :class="module.ability.includes('write') ? 'badge-write' : 'badge-read'">
                                <i v-if="module.ability.includes('write')" class="fas fa-pen me-1"></i>
                                <i v-else-if="module.ability.includes('read')" class="fas fa-eye me-1"></i>
                                {{ module.ability }}
                            </span>
                        </div>
                    </div>
                </div>
            </template>
        </o-modal>

        <!-- Delete Modal: User Attached Warning -->
        <div v-if="isWarningVisible && attachedUser > 0" class="modal-overlay" @click.self="hideWarning">
            <div class="modal-content">
                <!-- Header -->
                <div class="modal-header-custom">
                    <div class="modal-header-icon danger">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                    <div>
                        <h4>Role Is Currently In Use</h4>
                        <p class="modal-subtitle">Validation required before deleting this role</p>
                    </div>
                </div>

                <!-- Alert -->
                <div class="alert alert-danger">
                    <i class="fas fa-users me-2"></i>
                    <div>
                        <strong>{{ attachedUser }} user(s)</strong> are currently assigned to role <strong>"{{ roleToDelete }}"</strong>.
                    </div>
                </div>

                <p class="modal-desc">Please reassign these users to another role before deleting, or choose an option below.</p>

                <!-- Reassign Section -->
                <div class="reassign-section">
                    <label class="reassign-label">
                        <i class="fas fa-exchange-alt me-1"></i>
                        Reassign all users to another role:
                    </label>
                    <div class="reassign-row">
                        <select v-model="reassignTargetRole" class="form-control-modal" :disabled="isReassigning">
                            <option value="">-- Select target role --</option>
                            <option
                                v-for="role in availableRolesForReassign"
                                :key="role.name"
                                :value="role.name"
                            >
                                {{ role.name && role.name.length > 25 ? role.name.substring(0, 25) + '..' : role.name }}
                            </option>
                        </select>
                    </div>
                    <div v-if="reassignError" class="error-text">
                        <i class="fas fa-exclamation-circle me-1"></i> {{ reassignError }}
                    </div>
                </div>

                <!-- Force delete warning -->
                <div v-if="!reassignTargetRole" class="alert alert-force-delete-warning">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    <div>
                        <strong>Warning:</strong> If you force-delete this role without reassigning it, 
                        all <strong>{{ attachedUser }} user(s)</strong> assigned to this role will be <strong>permanently removed</strong> from the system.
                        This action cannot be undone.
                    </div>
                </div>

                <!-- Modal Actions -->
                <div class="modal-actions">
                    <button
                        v-if="reassignTargetRole"
                        class="btn-reassign-action"
                        @click="handleReassignAndDelete"
                        :disabled="isReassigning"
                    >
                        <span v-if="isReassigning">
                            <i class="fas fa-spinner fa-spin me-1"></i> Processing...
                        </span>
                        <span v-else>
                            <i class="fas fa-exchange-alt me-1"></i> Reassign & Delete
                        </span>
                    </button>
                    <button
                        v-else
                        class="btn-force-delete"
                        @click="handleDelete"
                        :disabled="isReassigning"
                    >
                        <i class="fas fa-trash-alt me-1"></i> Yes, Force Delete
                    </button>
                    <button class="btn-modal-cancel" @click="hideWarning" :disabled="isReassigning">
                        Cancel
                    </button>
                </div>
            </div>
        </div>

        <!-- Delete Modal: Simple Confirmation (no attached users) -->
        <o-warning-box
            v-if="isWarningVisible && attachedUser === 0"
            title="Delete Role"
            :item-name="roleToDelete || 'this role'"
            warning-message="There are no users currently assigned to this role. This action cannot be undone."
            confirm-text="Yes, Delete"
            cancel-text="Cancel"
            :is-loading="page.isLoading"
            @confirm="handleDelete"
            @cancel="hideWarning"
        />
    </div>
    <br>
</template>

<script>
import store from '@/store/'
import { mapState } from 'vuex'
import { OTable, OPagination, OBreadCrumb, OModal, OWarningBox } from '@/components/OmnihControl'
import { onMounted, onBeforeUnmount, reactive, ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from '@/composables/useToast'

export default {
    setup() {
        const { showToast } = useToast();
        const route = useRoute();
        const router = useRouter();
        let meta = computed(() => store.state.Role.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'user-roles'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    load_state();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                load_state();
            }

            // Check if redirected from create role page
            if (route.query.newRole === 'true') {
                store.dispatch('Role/read').then(() => {
                    const lastPage = meta.value.total;
                    if (lastPage > 1 && meta.value.page !== lastPage) {
                        const newMeta = { ...meta.value, page: lastPage };
                        store.commit('Role/switch_page', { meta: newMeta });
                        store.dispatch('Role/read');
                    }
                    router.replace({ name: 'Role' });
                });
            }
        });

        const write = ref(false);

        const searchCriteria = ref('');
        const isSearchActive = ref(false);

        let fields = ref([
            'No',
            'Name',
            'Permission',
            'Action'
        ]);

        const isModalVisible = ref(false);
        const selectedRoleName = ref('');
        const modalModules = ref([]);

        const thisComponentShow = ref(true);

        const roleSearch = ref([]);

        const selectRole = ref();
        const validation = ref('');

        const corporateId = ref('');

        const isWarningVisible = ref(false);
        const roleToDelete = ref(null);
        const attachedUser = ref(0);

        // Reassign state
        const reassignTargetRole = ref('');
        const isReassigning = ref(false);
        const reassignError = ref('');
        const availableRolesForReassign = ref([]);

        function showModal(){
            isModalVisible.value = true
        }

        function closeModal(){
            isModalVisible.value = false
        }

        function load_state() {
            page.isLoading = true;

            store.dispatch('Auth/getBusinessProfile').then(businessProfile => {

                const filter = {
                    corporate_id: businessProfile.corporate_id
                }
                corporateId.value = businessProfile.corporate_id;

                store.commit('Role/add_filter', { filter });

                store.dispatch('Role/read')
                    .catch((err) => {
                        validation.value = err.response.data.message;
                        console.error(err);
                        thisComponentShow.value = false;
                    }).finally(() => {
                        page.isLoading = false;
                        page.output = true
                    });
                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            });

        }

        function destroy(name) {
            page.isLoading = true;

            store.dispatch('Role/delete', { name, corporate_id: corporateId.value })
                .then(() => {
                    const roleName = name || 'this role';
                    const truncatedName = roleName.length > 25 ? roleName.substring(0, 25) + '...' : roleName;
                    showToast({
                        type: 'success',
                        title: 'Deleted',
                        message: `Role "${truncatedName}" has been deleted successfully.`
                    });
                    load_state()
                }).catch((err) => {
                    console.log(err);
                    validation.value = err.message;
                }).finally(() => {
                    page.isLoading = false;
                });
        }

        function navPage(page) {
            const _meta = { ...meta.value, page }

            console.log({ page });
            console.log({ _meta });
            store.commit('Role/switch_page', { meta: _meta })
            load_state()
        }

        function processedModules(modules) {
            return modules.map(module => {
                let ability = '';
                if (module.read) ability = 'read';
                if (module.write) ability = ability ? `${ability} & write` : 'write';
                return {
                    name: module.name,
                    ability
                };
            }).filter(module => module.ability)
            .sort((a, b) => a.name.localeCompare(b.name));
        }
        function doSearch() {
            if (searchCriteria.value) {
                let search = { name: searchCriteria.value };
                isSearchActive.value = true;

                store.commit('Role/set_search', { search });
                
                if (meta.value.page !== 1) {
                    const _meta = { ...meta.value, page: 1 };
                    store.commit('Role/switch_page', { meta: _meta });
                }

                page.isLoading = true;
                store.dispatch('Role/read').then(() => {
                    page.isLoading = false;
                });
            }
        }

        function showModules(item) {
            modalModules.value = item.modules;
            selectedRoleName.value = item.name;
            isModalVisible.value = true;
        }

        const formattedModuleName = (name) => {
            return name
                .replace(/[-_]/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase());
        }
        function clearSearch() {
            isSearchActive.value = false;
            searchCriteria.value = '';
            page.isLoading = true;

            store.commit('Role/clear_search');
            store.dispatch('Role/read').then(() => {
                page.isLoading = false;
            });
        }

        const showWarning = async (roleName) => {
            attachedUser.value = store.state.Role.roles.find(role => role.name === roleName).attachedUser;
            roleToDelete.value = roleName;
            reassignTargetRole.value = '';
            reassignError.value = '';
            isWarningVisible.value = true;

            // Pre-load available roles for reassignment (excluding the one being deleted)
            if (attachedUser.value > 0) {
                try {
                    const rolesData = await store.dispatch('Role/fetch_all_roles', corporateId.value);
                    availableRolesForReassign.value = rolesData.filter(
                        role => role.name !== roleName
                    );
                } catch (err) {
                    console.error('Failed to load roles for reassign:', err);
                }
            }
        };

        const hideWarning = () => {
            isWarningVisible.value = false;
            roleToDelete.value = null;
            reassignTargetRole.value = '';
            reassignError.value = '';
            isReassigning.value = false;
        };

        const handleDelete = () => {
            if (roleToDelete.value) {
                destroy(roleToDelete.value);
                hideWarning();
            }
        };

        const handleReassignAndDelete = async () => {
            if (!reassignTargetRole.value || !roleToDelete.value) return;

            isReassigning.value = true;
            reassignError.value = '';

            try {
                // Reassign all users to the target role first
                await store.dispatch('Role/reassign_users', {
                    from_role: roleToDelete.value,
                    to_role: reassignTargetRole.value,
                    corporate_id: corporateId.value
                });

                // Then delete the role
                await store.dispatch('Role/delete', {
                    name: roleToDelete.value,
                    corporate_id: corporateId.value
                });

                const roleName = roleToDelete.value || 'this role';
                const truncatedName = roleName.length > 25 ? roleName.substring(0, 25) + '...' : roleName;
                const targetName = reassignTargetRole.value || 'another role';
                const truncatedTargetName = targetName.length > 25 ? targetName.substring(0, 25) + '...' : targetName;

                showToast({
                    type: 'success',
                    title: 'Deleted & Reassigned',
                    message: `Role "${truncatedName}" deleted and users reassigned to "${truncatedTargetName}".`
                });

                hideWarning();
                load_state();
            } catch (err) {
                console.error('Reassign & delete failed:', err);
                reassignError.value = err?.message || 'Failed to reassign users. Please try again.';
            } finally {
                isReassigning.value = false;
            }
        };

        // Handler untuk Escape key
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                hideWarning();
            }
        };

        watch(isWarningVisible, (visible) => {
            if (visible) {
                window.addEventListener('keydown', handleEscKey);
            } else {
                window.removeEventListener('keydown', handleEscKey);
            }
        });

        onBeforeUnmount(() => {
            // Reset pagination state when leaving this module
            store.commit('Role/reset_meta');
            // Clean up event listener
            window.removeEventListener('keydown', handleEscKey);
        });

        return {
            destroy,
            page,
            load_state,
            fields,
            meta,
            navPage,
            processedModules,
            showModules,
            isModalVisible,
            selectedRoleName,
            modalModules,
            showModal,
            closeModal,
            formattedModuleName,            
            roleSearch,
            selectRole,
            searchCriteria,
            isSearchActive,
            doSearch,
            clearSearch,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            isWarningVisible,
            roleToDelete,
            showWarning,
            hideWarning,
            handleDelete,
            handleReassignAndDelete,
            attachedUser,
            reassignTargetRole,
            isReassigning,
            reassignError,
            availableRolesForReassign,
        }
    },
    computed: {
        ...mapState({
            roles: state => state.Role.roles
        }),
    },
    components: {
        OTable,
        OPagination,
        OBreadCrumb,
        OModal,
        OWarningBox
    }
}
</script>

<style scoped>
.module-item {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
}
.module-name {
    font-weight: lighter;
    margin-right: 10px;
}
.module-ability {
    flex-grow: 1;
    text-align: right;
}
.form-group {
    width: 250px;
    text-align: left;
    padding-left: 16px;
}

.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
    animation: fadeInOverlay 0.2s ease;
}

@keyframes fadeInOverlay {
    from { opacity: 0; }
    to   { opacity: 1; }
}

.modal-content {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    max-width: 520px;
    width: 95%;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideIn 0.25s ease;
}

.modal-content.modal-sm {
    max-width: 420px;
}

@keyframes slideIn {
    from { opacity: 0; transform: translateY(-16px); }
    to   { opacity: 1; transform: translateY(0); }
}

/* Modal header with icon */
.modal-header-custom {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.25rem;
}

.modal-header-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    flex-shrink: 0;
}

.modal-header-icon.danger {
    background: #fee2e2;
    color: #dc2626;
}

.modal-header-custom h4 {
    margin: 0 0 0.25rem 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #111827;
}

.modal-subtitle {
    margin: 0;
    font-size: 0.8125rem;
    color: #6b7280;
}

/* Alert inside modal */
.alert {
    padding: 0.875rem 1rem;
    border-radius: 8px;
    font-size: 0.875rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
}

.alert-danger {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

.alert-force-delete-warning {
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fde68a;
    animation: fadeInWarning 0.3s ease;
}

@keyframes fadeInWarning {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
}

.modal-desc {
    color: #4b5563;
    font-size: 0.875rem;
    margin-bottom: 1.25rem;
}

/* Reassign section */
.reassign-section {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
}

.reassign-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.625rem;
}

.reassign-row {
    display: flex;
    gap: 0.625rem;
    align-items: center;
    flex-wrap: wrap;
}

.form-control-modal {
    flex: 1;
    min-width: 160px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem;
    background: white;
    color: #111827;
    transition: border-color 0.2s;
}

.form-control-modal:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-control-modal:disabled {
    background: #f3f4f6;
    cursor: not-allowed;
}

.btn-reassign {
    padding: 0.5rem 1rem;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    white-space: nowrap;
    transition: background 0.2s;
}

.btn-reassign:hover:not(:disabled) {
    background: #2563eb;
}

.btn-reassign:disabled {
    background: #9ca3af;
    cursor: not-allowed;
}

.error-text {
    margin-top: 0.5rem;
    font-size: 0.8125rem;
    color: #dc2626;
}

/* Modal action buttons */
.modal-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 0.5rem;
}

.btn-force-delete {
    padding: 0.625rem 1rem;
    background: white;
    color: #dc2626;
    border: 1.5px solid #fca5a5;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    transition: all 0.2s;
}

.btn-force-delete:hover:not(:disabled) {
    background: #fee2e2;
    border-color: #dc2626;
}

.btn-force-delete:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-reassign-action {
    padding: 0.625rem 1rem;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    transition: all 0.2s;
}

.btn-reassign-action:hover:not(:disabled) {
    background: #2563eb;
}

.btn-reassign-action:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-danger-confirm {
    padding: 0.625rem 1.25rem;
    background: #dc2626;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    transition: background 0.2s;
}

.btn-danger-confirm:hover {
    background: #b91c1c;
}

.btn-modal-cancel {
    padding: 0.625rem 1.25rem;
    background: white;
    color: #6b7280;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-modal-cancel:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #9ca3af;
}

.btn-modal-cancel:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width: 480px) {
    .modal-content {
        padding: 1.25rem;
    }
    .reassign-row {
        flex-direction: column;
        align-items: stretch;
    }
    .modal-actions {
        flex-direction: column-reverse;
    }
    .btn-force-delete,
    .btn-danger-confirm,
    .btn-modal-cancel {
        width: 100%;
        justify-content: center;
    }
}


.validation-banner {
    margin-top: 1rem;
    animation: slideInBanner 0.35s ease;
}

@keyframes slideInBanner {
    from { opacity: 0; transform: translateY(-10px); }
    to   { opacity: 1; transform: translateY(0); }
}

.validation-banner-inner {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 0.875rem 1.125rem;
    background: linear-gradient(135deg, #fff5f5, #fee2e2);
    border: 1px solid #fca5a5;
    border-left: 4px solid #dc2626;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
}

.validation-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fee2e2;
    color: #dc2626;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
}

.validation-message {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}

.validation-message strong {
    font-size: 0.8125rem;
    font-weight: 700;
    color: #991b1b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.validation-message span {
    font-size: 0.875rem;
    color: #b91c1c;
    line-height: 1.4;
}

.validation-close {
    background: transparent;
    border: none;
    color: #dc2626;
    font-size: 0.875rem;
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 6px;
    transition: background 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.validation-close:hover {
    background: rgba(220, 38, 38, 0.1);
}

/* Styling for filter and actions (migrated from MemberTier) */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    max-width: 350px;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
    flex-wrap: wrap;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color, #0d6efd);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s;
    overflow: hidden;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

.search-input-wrapper input {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.btn-search:hover {
    background: #e2e8f0;
    color: var(--primary-color, #0d6efd);
}

.search-input-wrapper .btn-search {
    position: relative;
    width: 44px;
    height: 42px;
    border-radius: 0;
    background: transparent;
}

.search-input-wrapper .btn-search:hover {
    background: #f1f5f9;
}

.search-input-wrapper .btn-search::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1.1px;
    height: 60%;
    background: linear-gradient(to bottom, rgba(203, 213, 225, 0), rgba(203, 213, 225, 1), rgba(203, 213, 225, 0));
    pointer-events: none;
}

.action-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 8px;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-action-secondary {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
    cursor: pointer;
}

.btn-action-secondary:hover {
    background-color: #e2e8f0;
    color: #1e293b;
}

.btn-add {
    background-color: var(--primary-color, #0d6efd);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

.member-list-table {
    white-space: nowrap;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.member-list-table th,
.member-list-table td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

.member-row-clickable {
    transition: background-color 0.2s;
}

.member-row-clickable:hover {
    background-color: #f8fafc !important;
}

.btn-action {
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
}

.btn-info-action {
    background-color: #eff6ff;
    color: #1e40af;
}

.btn-info-action:hover {
    background-color: #dbeafe;
    color: #1e3a8a;
}

.btn-edit {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-edit:hover {
    background-color: #e5e7eb;
    color: #111827;
}

.btn-delete {
    background-color: #fff1f2;
    color: #9f1239;
}

.btn-delete:hover {
    background-color: #ffe4e6;
    color: #be123c;
}

.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    text-align: left;
}

@media (max-width: 768px) {
    .filter-action-wrapper {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
    }

    .filter-controls {
        width: 100%;
    }
    
    .search-box-custom {
        width: 100%;
        max-width: 100%;
    }

    .search-type-tabs {
        width: 100%;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding: 6px;
        background: #f8fafc;
        scrollbar-width: none;
    }

    .search-type-tabs::-webkit-scrollbar {
        display: none;
    }

    .tab-btn {
        flex: 0 0 auto;
        white-space: nowrap;
    }

    .action-buttons-group {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    
    .btn-refresh {
        width: 100%;
    }

    .btn-action-secondary {
        width: 100%;
        justify-content: center;
        padding: 0 12px;
    }

    .btn-add {
        grid-column: span 2;
        width: 100%;
        justify-content: center;
        margin-top: 4px;
    }
}

/* Modern Permissions Modal Styling (Simple List) */
.permission-simple-list {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.permission-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #ffffff;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s ease;
}

.permission-list-item:last-child {
    border-bottom: none;
}

.permission-list-item:hover {
    background: #f8fafc;
}

.permission-name-inline {
    font-size: 0.95rem;
    font-weight: 500;
    color: #1e293b;
}

.permission-badges {
    display: flex;
}

.badge-simple {
    padding: 6px 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
    border-radius: 6px;
    border: 1px solid transparent;
}

.badge-read {
    background-color: #eff6ff;
    color: #3b82f6;
    border-color: #bfdbfe;
}

.badge-write {
    background-color: var(--secondary-color, #e4ecf7);
    color: var(--primary-color, #0d6efd);
    border-color: var(--primary-color, #0d6efd);
}
</style>